import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import CloseSvg from 'shared/statics/svg/Close.svg';

export default function SearchInput({ onInput, ...props }) {
  const [value, setValue] = useState('');

  const handleInput = useCallback(event => {
    setValue(event.target.value);
    onInput(event);
  }, [onInput]);
  const handleClear = useCallback(() => {
    setValue('');
    onInput({ target: { value: '' } });
  }, [onInput]);

  return (
    <SearchInputInner
      {...props}
      {... { value }}
      onClear={handleClear}
      onInput={handleInput}
    />
  );
}

const SearchInputInner = styled(TextField).attrs(({ placeholder = 'Search', filter = '', onClear }) => ({
  placeholder,
  InputProps: {
    startAdornment: (
      <InputAdornment position="start" onClick={filter.length === 0 ? undefined : onClear}>
        {filter.length === 0 ? <SearchIcon /> : <CloseIcon />}
      </InputAdornment>
    ),
  }
}))`
input {
  &::-webkit-search-cancel-button { 
		-webkit-appearance: none;
		background-color: transparent;
		padding: 20px;
    z-index: 1;
  }
}
`;

export const SearchInputContainer = ({ maxWidth, children }) => (
  <ContainerRoot {...{ maxWidth }}>
    {children}
    <SearchIcon />
  </ContainerRoot>
);

const Padding = styled.div`
  padding-right: 10px;
`;

const ContainerRoot = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 48px;
  ${({ maxWidth }) => `max-width: ${maxWidth}px;`}
`;

const SearchIcon = styled.img.attrs({
  src: '/images/svg/Search.svg',
})`
  margin-top: 2px;
  width: 15px;
  height: 15px;
  position: absolute;
  right: 25px;
`;

const CloseIcon = styled.img.attrs({
  src: CloseSvg,
})`
  margin-top: 2px;
  width: 15px;
  height: 15px;
  position: absolute;
  right: 25px;
  color: 666666;
  cursor: pointer;
`;

